module.exports = __webpack_public_path__ + "static/media/php.1fa57934.png";